// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2N87F","content":"LoadingAlert_content__1OVJZ"};